export default __webpack_public_path__ + "static/media/checkbox_selected_hover_mobile.71b641eb.svg";